import BaseListagem from "components/BaseListagem";
import { Column } from "primereact/column";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import FeriadoAdmService from "service/administracao/cadastro/FeriadoAdmService";
import { converterData, converterDataDiaMes } from "utils/convert";

const feriadoService = new FeriadoAdmService();

export default function FeriadoAdmListagem() {

    const [queryParameters] = useSearchParams();

    useEffect(() => {
    }, []);

    return (

        <BaseListagem ordenacao="nome,ASC" service={feriadoService} urlService="/feriadoadm" tituloPagina={'Feriados - Administração'} >
            <Column field="nome" header="Nome" />
            <Column field="data" header="Data" body={(data) => data.replicaAnualmente ? converterDataDiaMes(data.data) : converterData(data.data)} />
            <Column field="cobrareplicaAnualmentenca" header="Tipo" body={(data) => data.replicaAnualmente ? 'Todos os anos' : 'Único'} />
        </BaseListagem>
    )
}
